import { render, staticRenderFns } from "./AcquisitionStudioComparison.vue?vue&type=template&id=5e4def3f&scoped=true"
import script from "./AcquisitionStudioComparison.vue?vue&type=script&lang=js"
export * from "./AcquisitionStudioComparison.vue?vue&type=script&lang=js"
import style0 from "./AcquisitionStudioComparison.vue?vue&type=style&index=0&id=5e4def3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4def3f",
  null
  
)

export default component.exports